import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ref } from 'vue'
import instance from '@/api/instance'
import { Document } from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageFile',
  props: {
    title: {},
    src: {}
  },
  setup(__props: any) {

const props = __props

const loading = ref<boolean>(false)

const downloadFile = async () => {
  loading.value = true

  try {
    const response = await instance.get(props.src, {
      responseType: 'blob'
    })

    const url = URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = url
    link.download = props.title
    link.click()
    URL.revokeObjectURL(url)
    loading.value = false
  } catch (error) {
    console.error('Ошибка загрузки файла:', error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_link, {
    href: "#",
    type: "primary",
    onClick: _withModifiers(downloadFile, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [
          _createVNode(_unref(Document))
        ]),
        _: 1
      }),
      _createTextVNode(" " + _toDisplayString(props.title), 1)
    ]),
    _: 1
  })), [
    [_directive_loading, loading.value]
  ])
}
}

})